import { StyledMenuItem } from "@/mds/components/menu/action-menu/action-menu.style";
import { MDSMenuItem, MDSMenuItemVariant } from "@/mds/components/menu/menu-item";
import { MDSActionMenuItemProps } from "@/mds/components/menu/action-menu/action-menu.types";

export const MDSActionMenuItem = ({
  variant = MDSMenuItemVariant.OneLine,
  onClick, // Extract onClick to prevent double clicks
  onHover,
  ...props
}: MDSActionMenuItemProps) => {
  return (
    <StyledMenuItem
      data-mds-name="action-menu-item"
      id={props.id}
      key={props.id}
      aria-label={props.label}
      textValue={props.textValue ?? props.label}
      onClick={onClick}
      onHoverStart={onHover}
      isDisabled={props.isDisabled}
    >
      <MDSMenuItem variant={variant} {...props} />
    </StyledMenuItem>
  );
};
